// src/services/openAIService.js

const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

export async function sendMessageToOpenAI(messages) {
  try {
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${OPENAI_API_KEY}`
      },
      body: JSON.stringify({
        model: "gpt-3.5-turbo",
        messages: messages,
        temperature: 0.7,
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.choices[0].message.content;
  } catch (error) {
    console.error('Error calling OpenAI:', error);
    throw error;
  }
}

export async function getTaskHelp(task) {
  const taskItems = task.items.map(item => `• ${item.text}`).join('\n');
  
  const systemPrompt = `You are a helpful assistant that specializes in task management and productivity. 
When helping with tasks, structure your responses in the following format:

📋 Task Overview
[Provide a brief summary of the task]

✅ Task Details:
[List the task items]

💡 Analysis:
[Brief analysis of what the task involves]

❓ How can I help?
[Ask a specific question about how you can assist with this task]

Keep your responses concise and well-structured.`;

  const userPrompt = `Please help me with this task:
  
Task Name: ${task.name}
Task Items:
${taskItems}`;

  const messages = [
    { role: "system", content: systemPrompt },
    { role: "user", content: userPrompt }
  ];

  return sendMessageToOpenAI(messages);
}